export class CustomHeaders {
  Authorization: string;
  SelectedCulture: string;
  GraphToken: string;
  CoreApiToken: string;
  AdoToken: string;
  'Cache-Control': string;
  Pragma: string;
  Expires: string;
}
